<template>
  <NodePressRelease v-if="node" v-bind="node" />
</template>

<script lang="ts" setup>
import type { NodePressReleaseFragment } from '#graphql-operations'

definePageMeta({
  path: '/medienmitteilung/:slug(.*)*',
  languageMapping: {
    fr: '/fr/communiques-de-presse/:slug(.*)*',
    it: '/it/comunicati-stampa/:slug(.*)*',
  },
  drupalRoute: true,
})

const nuxtRoute = useRoute()

const { data: query } = await useAsyncGraphqlQuery(
  'routeNodePressRelease',
  {
    path: nuxtRoute.path,
  },
  {
    transform: (v) => v.data,
    graphqlCaching: {
      client: true,
    },
  },
)

const { entity: node } = await useDrupalRoute<NodePressReleaseFragment>(
  query.value,
)

setBreadcrumbLinksFromRoute(query.value)
setLanguageLinksFromRoute(query.value)
useRouteCache((c) => c.setCacheable().setMaxAge(600))
await renderPageDependencies()
</script>

<script lang="ts">
export default {
  name: 'PagePressReleaseSlug',
}
</script>
